import { disableFullscreenIfEnabled } from '../../gameClient/webgl/fullscreenFixer';
import { PaymentObject } from '../../types/payments';

type PayParams = {
    pmObject: PaymentObject
};

export class PayHandler {
    public handle(params: PayParams): void {
        window.app.pay(params.pmObject);
        disableFullscreenIfEnabled();
    }
}
